import { createApi } from '@reduxjs/toolkit/query/react';
import { API, API_PREFIX } from '../../constants';
import { CreateTagsRequest, DeleteTagRequest, ResponseTag } from '../../models/tag.model';
import { baseQuery } from './base.query';

export const tagsApi = createApi({
  reducerPath: 'tagsApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getTagList: builder.query<ResponseTag[], number>({
      query: () => ({
        url: `${API_PREFIX.NEXTGEN}${API.TAGS}/get-tags`,
      }),
    }),
    deleteTag: builder.mutation<unknown, DeleteTagRequest>({
      query: (args: DeleteTagRequest) => ({
        method: 'DELETE',
        url: `${API_PREFIX.NEXTGEN}${API.TAGS}/delete-tag?tagid=${args.tagId}&objectId=${args.objectId}`,
      }),
    }),
    saveTags: builder.mutation<unknown, CreateTagsRequest>({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.TAGS}/create-tag`,
        method: 'POST',
        body: args,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetTagListQuery, useSaveTagsMutation, useDeleteTagMutation } = tagsApi;
